module.exports = __webpack_public_path__ + "static/media/maps.d4d9a247.png";